/* eslint-disable no-multi-assign */
/* eslint-disable no-bitwise */
import { isEmpty, each, merge, extend, get, indexOf } from 'lodash';
import axios from 'axios';
import { MDTAnalytics } from './mdtanalytics.js';
import { MDTApp } from '../actions/bootAction.js';
import { sendEventTrackingData, isTranslatableLabel } from '../helpers/commonUtils.js';
import constants from '../helpers/constants.js';
import { saveAndFormatFilterData } from '../helpers/storageUtility.js';

let reduxStore;
const registerStore = (store) => {
    reduxStore = store;
};

window.pageLoadTimer = '';
export const MDTApi = {
    setDefaultPathVar,
    updateQueryStringParam,
    getPathvariables,
    processPathVariables,
    call,
    download,
    downloadBlob,
    directCall,
    registerStore,
};

function processConfigData(config) {
    if (config.params?.sessionKey) {
        return { ...config, params: saveAndFormatFilterData(config.params) };
    }
    if (config.data?.sessionKey) {
        return { ...config, data: saveAndFormatFilterData(config.data) };
    }
    return config;
}

function setDefaultPathVar(name, value) {
    if (value === undefined) {
        delete MDTSetting.pathVars[name];
    } else {
        MDTSetting.pathVars[name] = value;
    }
}

function updateQueryStringParam(key, value, uri) {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, `$1${key}=${value}$2`);
    }
    return `${uri + separator + key}=${value}`;
}

function getPathvariables() {
    return MDTSetting.pathVars;
}
/*
         RiotBus.requestStore('me', MDTApi);
     },
 */
function handleGenericError(jqXHR, callback) {
    let msg = '';
    const title = '';

    const status = [404, 504, 408];
    if (indexOf(jqXHR.status, status) > -1 && isEmpty(jqXHR.data)) {
        msg = 'genericXHRTimeOutMessage';
    } else if (jqXHR.status) {
        if (jqXHR.data.errorCode) {
            msg =
                jqXHR.data.message ||
                `${jqXHR.data.developerMessage ? jqXHR.data.developerMessage.replace('user.', '') : jqXHR.data.userMessage}`;
        } else {
            msg = jqXHR.data.message || jqXHR.data.userMessage || 'genericXHRTimeOutMessage';
        }
    }

    if (isTranslatableLabel(msg)) {
        msg = !!window.t && window.t(msg);
    }

    if (callback && typeof callback === 'function') {
        callback(msg, 'error', title);
    } else if (typeof callback !== 'function') {
        throw Error('Callback must be a function');
    }
}

function handleUnauthorised(jqXHR) {
    if (jqXHR && jqXHR.status === 422) {
        localStorage.removeItem('customer');
        const appId = window.routeSettings.appRoute;
        MDTApp.goto(`/apps/${appId}/`);
    }
}

async function setUserAuthToken() {
    const { buid, basesiteid } = MDTSetting.pathVars;

    // // TODO: Clean this up in the future to use fetchAuthSession instead of what we have in localStorage 20250401:Alevale
    //     const authSession = await fetchAuthSession({ forceRefresh: true });
    //     const { accessToken } = authSession.tokens ?? {};
    //     console.log('use this as accessToken', accessToken.toString());

    const token = localStorage.getItem('apiToken');
    const appid = MDTApp.getSetting('appid');
    const isCustomHeaders = MDTSetting.customHeaders;
    axios.defaults.headers.common['X-Trans-Id'] = guid();
    axios.defaults.headers.common['X-Base-Site-Id'] = basesiteid;
    axios.defaults.headers.common['X-Bu-Id'] = buid;
    if (!!token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    axios.defaults.headers.common['App-Id'] = appid;

    if (isCustomHeaders) {
        axios.defaults.headers.common['X-Correlation-Id'] = guid();
        axios.defaults.headers.common['X-Caller-Name'] = appid;
    }
}

/**
 * Process the path variable inside the URL, based on {} marker
 *
 * @param url String the url
 * @param pathVars Object Path variables to process in the URL. Key of properties are used to target the path variable
 * @returns the processed url
 */
export function processPathVariables(url, pathVars) {
    if (!isEmpty(pathVars)) {
        each(pathVars, function (value, key) {
            url = url.replace(`{${key}}`, encodeURIComponent(value));
        });
    }

    return url;
}

function buildErrorHandlerConfig(axiosConfig) {
    const config = {};

    config.error = axiosConfig.errorCallback || handleGenericError;

    return config;
}

function getDefaultRequestConfig(appXhrConfig) {
    const axiosConfig = {
        // `method` is the request method to be used when making the request
        method: 'GET', // default

        // `headers` are custom headers to be sent
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };

    if (appXhrConfig.setBuidSiteIdInHeader) {
        const { buid, basesiteid } = MDTSetting.pathVars;
        axiosConfig.headers['X-Base-Site-id'] = basesiteid;
        axiosConfig.headers['X-Bu-id'] = buid;
        delete appXhrConfig.setBuidSiteIdInHeader;
    }

    return merge(axiosConfig, appXhrConfig);
}

// shamelessly taken from: https://gist.github.com/LeverOne/1308368
// TODO: use https://github.com/broofa/node-uuid when we move to webpack
function guid(a, b) {
    for (
        b = a = '';
        a++ < 36;
        b +=
            (a * 51) & 52
                ? (a ^ 15 ? 8 ^ (Math.random() * (a ^ 20 ? 16 : 4)) : 4).toString(16)
                : '-'
    );
    return b;
}

function trackPageLoadTime(pageEndTime) {
    // Capturing page load time if pageLoadStartTime time is not blank,
    // Which is setup in the onBeforeChange function of the App (options.js)
    if (!!pageEndTime && !!window.pageLoadStartTime) {
        const pageLoadTime = (pageEndTime - window.pageLoadStartTime) / 1000; // Capturing page load time in seconds.
        MDTAnalytics.track(
            {
                pageLoadEventInfo: {
                    ...window.digitalData.pageInfo,
                    ...{ pageLoadTime: pageLoadTime },
                },
            },
            true
        );

        // Resetting page load time capture for internal API call.
        window.pageLoadStartTime = '';
        window.pageLoadTimer = '';
    }
}
function handlePageLoadTime() {
    // Capturing page load time if config available in app settings.
    if (!!MDTSetting.capturePageLoadTime) {
        // Capturing End page load time including all API timing
        window.pageLoadTimer = setTimeout(() => {
            if (!!window.pageLoadStartTime) {
                // Subtracting 1000 milliseconds from the last time causes the setTimeout function setup for 1000 milliseconds
                trackPageLoadTime(new Date().getTime() - 1000);
            }
        }, 1000);
    }
}
function xhrComplete() {
    MDTSetting.xhr--;
    if (MDTSetting.xhr === 0) {
        xhrLoader(false);
        handlePageLoadTime();
    }
}

function xhrLoader(flag) {
    if (flag) {
        MDTSetting.xhr++;
        if (!!MDTSetting.capturePageLoadTime && !!window.pageLoadTimer) {
            clearTimeout(window.pageLoadTimer); // Reset capture time if some more API triggers during page load time
        }
    }

    return flag;
}

function fetchUrlQuery(url) {
    let match;
    const urlParams = {};
    const pl = /\+/g; // Regex for replacing addition symbol with a space
    const search = /([^&=]+)=?([^&]*)/g;
    const decode = function (s) {
        return decodeURIComponent(s.replace(pl, ' '));
    };
    const query = url.substring(url.indexOf('?') + 1);

    // eslint-disable-next-line no-cond-assign
    while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);

    return urlParams;
}

function incrementXHRLoaderCounter() {
    if (reduxStore) {
        reduxStore.dispatch({ type: constants.INCREMENT_LOADING_ELEMENTS });
    }
}

function decrementXHRLoaderCounter() {
    if (reduxStore) {
        reduxStore.dispatch({ type: constants.DECREMENT_LOADING_ELEMENTS });
    }
}

/**
 *
 * @param webserviceURL String Name of the web service used to retrieve its complete url in the app-settings file.
 * @param pathVars Object Path variables to eventually process in the URL. Key of properties are used to target
 *     the path variable
 * @param config
 */
async function call(webservice, config, pathVars, showLoader, sendCompleteResponse) {
    if (typeof showLoader === 'undefined' || showLoader !== false) {
        showLoader = true;
        showLoader = xhrLoader(showLoader);
        incrementXHRLoaderCounter();
    }

    // Webservice must exists in settings
    if (!MDTApp.getSetting(webservice)) {
        console.error(`Webservice not found, is "${webservice}" correct ?`);
        return;
    }

    pathVars = extend(MDTSetting.pathVars, pathVars);

    // Build URL with all path variables
    let url = processPathVariables(MDTApp.getSetting(webservice), pathVars);

    let culture =
        !!localStorage.getItem('I18N_LANGUAGE') &&
        localStorage.getItem('I18N_LANGUAGE') !== 'undefined'
            ? localStorage.getItem('I18N_LANGUAGE')
            : 'en';
    if (culture) {
        if (culture.toLowerCase() === 'dev') {
            culture = 'en';
        }

        culture = culture.replace('_', '-');
    }

    url = updateQueryStringParam('locale', culture, url);
    if (config.method && config.method.toLowerCase() === 'get' && !config.cache) {
        url = updateQueryStringParam('_', Date.now(), url);
    }

    config = processConfigData(config);

    const getDefaultQuery = fetchUrlQuery(url);
    config.params = { ...config.params, ...getDefaultQuery };
    [url] = url.split('?');

    let axiosConfig = getDefaultRequestConfig(config || {});

    axiosConfig.showLoader = showLoader;
    // Url property in ajax axiosConfig is forbidden
    if (axiosConfig.hasOwnProperty('url')) {
        decrementXHRLoaderCounter();
        console.error(
            'MDTApi.call error: Url property is not allowed in axiosConfig object, please use webservice param instead'
        );
        throw new Error(
            'MDTApi.call error: Url property is not allowed in axiosConfig object, please use webservice param instead'
        );
    }

    // Check if there are filter restrictions and append them to the API url
    if (axiosConfig.restrictionFilter) {
        url = updateQueryStringParam('restrictionFilter', axiosConfig.restrictionFilter, url);
    }

    // Check that no path variable remains in the URL
    if (url.indexOf('{') !== -1 || url.indexOf('}') !== -1) {
        decrementXHRLoaderCounter();
        console.error(`Some path variables were not processed : "${url}"`);
        throw new Error(`Some path variables were not processed : "${url}"`);
    }

    // Merge default options with config
    axiosConfig = Object.assign(axiosConfig, buildErrorHandlerConfig(axiosConfig));
    // Set XHR call header
    await setUserAuthToken();

    // before sending the request, we will track this for our analytics
    if (config.tracking) {
        const { data, hasEvent = false } = config.tracking;
        MDTAnalytics.track(data, hasEvent);
    }

    if (config.responseType) {
        axiosConfig.responseType = config.responseType;
        axiosConfig.headers.Accept = '*/*';
    }

    const XhrRes = await axios(url, axiosConfig)
        .then(function (response) {
            if (response.config.successCallback && sendCompleteResponse)
                response.config.successCallback(response); // send the complete response including the headers if 'sendCompleteResponse' is true
            else if (response.config.successCallback)
                response.config.successCallback(response.data);

            if (showLoader) xhrComplete();
            return sendCompleteResponse ? response : response.data;
        })
        .catch(function (error) {
            if (showLoader) xhrComplete();

            if (error && error.config && error.config.error) {
                handleUnauthorised(error.response);
                error.config.error(error.response, MDTApp.showNotification);
            }
            const eventParamOnClick = {
                eventCategory: 'error',
                eventAction: get(digitalData, 'pageInfo.pageName', ''),
                processActions: false,
                eventLabel: {
                    label: get(error, 'response.statusText', ''),
                    name: 'error',
                },
            };
            sendEventTrackingData(eventParamOnClick);
        })
        .finally(() => {
            // NOTE: Independently of the rest, always set the loader as false at the end of the API call 20240703:Alevale
            if (showLoader) decrementXHRLoaderCounter();
        });

    return XhrRes;
}

function download(
    webservice,
    pathVars,
    qsParams = {},
    includeAccessToken,
    returnUrl,
    method,
    customHeaders
) {
    // Webservice must exists in settings

    if (!MDTApp.getSetting(webservice)) {
        console.error(`Webservice not found, is "${webservice}" correct ?`);
        return;
    }

    pathVars = extend(MDTSetting.pathVars, pathVars);

    // Build URL with all path variables
    let url = this.processPathVariables(MDTApp.getSetting(webservice), pathVars);

    // Check that no path variable remains in the URL
    if (url.indexOf('{') !== -1 || url.indexOf('}') !== -1) {
        console.error(`Some path variables were not processed : "${url}"`);
        return;
    }

    let culture =
        !!localStorage.getItem('I18N_LANGUAGE') &&
        localStorage.getItem('I18N_LANGUAGE') !== 'undefined'
            ? localStorage.getItem('I18N_LANGUAGE')
            : 'en';
    if (culture) {
        if (culture.toLowerCase() === 'dev') {
            culture = 'en';
        }

        culture = culture.replace('_', '-');
    }

    // Add manually access token on URL
    if (includeAccessToken !== false) {
        url += `?access_token=${localStorage.getItem('apiToken') || ''}`;
    }
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    if (!isEmpty(qsParams)) {
        url +=
            separator +
            Object.keys(qsParams)
                .map((key) => `${key}=${encodeURIComponent(qsParams[key])}`)
                .join('&');
    }

    url = updateQueryStringParam('locale', culture, url);

    const downloadResult = call(
        webservice,
        {
            method: method || 'GET',
            params: !!method && method === 'POST' ? '' : qsParams,
            data: !!method && method === 'POST' ? qsParams.data || {} : '',
            headers: customHeaders && customHeaders,
        },
        pathVars
    );

    return downloadResult
        .then(function (response) {
            if (response.DeveloperMessage) {
                MDTApp.showNotification([response.DeveloperMessage]);
            } else {
                if (!!returnUrl) {
                    return url;
                }

                try {
                    window.location = url;
                } catch (e) {
                    console.error('Error in downloading file', e);
                }
            }
        })
        .catch(function (error) {
            if (error && error.config && error.config.error)
                error.config.error(error.response, MDTApp.showNotification);
            throw error.response;
        });
}

function downloadBlob(webservice, pathVars, qsParams = {}, includeAccessToken, returnUrl, method) {
    // Webservice must exists in settings

    if (!MDTApp.getSetting(webservice)) {
        console.error(`Webservice not found, is "${webservice}" correct ?`);
        return;
    }

    pathVars = extend(MDTSetting.pathVars, pathVars);

    // Build URL with all path variables
    let url = this.processPathVariables(MDTApp.getSetting(webservice), pathVars);

    // Check that no path variable remains in the URL
    if (url.indexOf('{') !== -1 || url.indexOf('}') !== -1) {
        console.error(`Some path variables were not processed : "${url}"`);
        return;
    }

    let culture =
        !!localStorage.getItem('I18N_LANGUAGE') &&
        localStorage.getItem('I18N_LANGUAGE') !== 'undefined'
            ? localStorage.getItem('I18N_LANGUAGE')
            : 'en';
    if (culture) {
        if (culture.toLowerCase() === 'dev') {
            culture = 'en';
        }

        culture = culture.replace('_', '-');
    }

    // Add manually access token on URL
    if (includeAccessToken !== false) {
        url += `?access_token=${localStorage.getItem('apiToken') || ''}`;
    }
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    if (!isEmpty(qsParams)) {
        url +=
            separator +
            Object.keys(qsParams)
                .map((key) => `${key}=${encodeURIComponent(qsParams[key])}`)
                .join('&');
    }

    url = updateQueryStringParam('locale', culture, url);

    const handleResponseError = (error) => {
        if (
            error &&
            error.request.responseType === 'blob' &&
            error.data instanceof Blob &&
            error.data.type &&
            error.data.type.toLowerCase().indexOf('json') !== -1
        ) {
            const reader = new FileReader();
            reader.onload = () => {
                error.data = JSON.parse(reader.result);
                if (error.data) {
                    const errorMsg =
                        !!window.t &&
                        window.t(error.data.developerMessage || 'genericXHRTimeOutMessage');
                    MDTApp.showNotification([errorMsg]);
                }
            };
            reader.readAsText(error.data);
        } else {
            const errorMsg =
                !!window.t &&
                window.t(
                    error.data.message || error.data.userMessage || 'genericXHRTimeOutMessage'
                );
            MDTApp.showNotification([errorMsg]);
        }
    };

    const downloadResult = call(
        webservice,
        {
            method: method || 'GET',
            params: !!method && method === 'POST' ? '' : qsParams,
            data: !!method && method === 'POST' ? qsParams.data || {} : '',
            responseType: 'blob',
            errorCallback: (error) => handleResponseError(error),
        },
        pathVars,
        true,
        true
    );

    return downloadResult
        .then(async (response) => {
            let { data } = response;
            // Checking any developer error message with success response during blob type download
            if (response?.request?.responseType === 'blob' && data instanceof Blob && data.type) {
                const text = await data.text();

                data = data?.type.toLowerCase().includes('json') ? JSON.parse(text) : text;
            }
            if (data.developerMessage) {
                // Notification display if developer message available in response
                MDTApp.showNotification([data.developerMessage]);
            } else {
                const fileName = returnFileName(response);
                const a = document.createElement('a');
                const url = new Blob([response.data], { type: 'octet/stream' });
                a.href = URL.createObjectURL(url);
                a.download = fileName;
                a.click();
            }
        })
        .catch(function (error) {
            if (error && error.config && error.config.error)
                error.config.error(error.response, MDTApp.showNotification);
            throw error.response;
        });
}

function returnFileName(response) {
    let filename = '';
    // reading the filename from content-disposition in the response header.
    const contentDisposition = response.request.getResponseHeader('Content-Disposition');
    if (
        contentDisposition &&
        (contentDisposition.indexOf('inline') !== -1 ||
            contentDisposition.indexOf('attachment') !== -1)
    ) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    return filename;
}

async function directCall(
    webservice,
    config,
    pathVars,
    showLoader,
    sendCompleteResponse,
    downloadable
) {
    if (typeof showLoader === 'undefined' || showLoader !== false) {
        showLoader = true;
        showLoader = xhrLoader(showLoader);
        incrementXHRLoaderCounter();
    }

    if (typeof downloadable === 'undefined' || showLoader === false) {
        downloadable = false;
    }

    let axiosConfig = getDefaultRequestConfig(config || {});
    axiosConfig.showLoader = showLoader;
    axiosConfig = Object.assign(axiosConfig, buildErrorHandlerConfig(axiosConfig));
    await setUserAuthToken();
    if (config.responseType) {
        axiosConfig.responseType = config.responseType;
        axiosConfig.headers.Accept = '*/*';
    }
    const XhrRes = await axios(webservice, axiosConfig)
        .then(function (response) {
            if (response.config.successCallback && sendCompleteResponse)
                response.config.successCallback(response); // send the complete response including the headers if 'sendCompleteResponse' is true
            else if (response.config.successCallback)
                response.config.successCallback(response.data);

            if (showLoader) xhrComplete();
            return sendCompleteResponse ? response : response.data;
        })
        .catch(function (error) {
            if (showLoader) xhrComplete();

            if (error && error.config && error.config.error) {
                handleUnauthorised(error.response);
                error.config.error(error.response, MDTApp.showNotification);
            }

            throw error.response;
        })
        .finally(() => {
            if (showLoader) decrementXHRLoaderCounter();
        });
    if (downloadable) {
        downloadFile(XhrRes);
    } else {
        return XhrRes;
    }
}
function downloadFile(response) {
    const headerContentDisp = response.headers['content-disposition'];
    const filename =
        headerContentDisp && headerContentDisp.split('filename=')[1].replace(/["']/g, '');
    const contentType = response.headers['content-type'];
    const a = document.createElement('a');
    const url = new Blob([response.data], { contentType });
    a.href = window.URL.createObjectURL(url);
    a.download = filename;
    a.click();
}
